import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const UnlockSignalsModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 z-50 flex items-center justify-center p-4"
        onClick={onClose}
      >
        {/* Backdrop */}
        <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" />
        
        {/* Modal */}
        <motion.div
          initial={{ scale: 0.9, opacity: 0, y: 20 }}
          animate={{ scale: 1, opacity: 1, y: 0 }}
          exit={{ scale: 0.9, opacity: 0, y: 20 }}
          onClick={(e) => e.stopPropagation()}
          className="relative z-10 bg-white rounded-2xl shadow-2xl max-w-md w-full p-8 font-inter"
        >
          {/* Close button */}
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-[#6b7280] hover:text-[#151a1a] transition-colors"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>

          {/* Icon */}
          <div className="flex justify-center mb-6">
            <div className="w-16 h-16 bg-gradient-to-br from-[#4878ff] to-[#16c784] rounded-full flex items-center justify-center">
              <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
              </svg>
            </div>
          </div>

          {/* Title */}
          <h2 className="text-2xl font-semibold text-[#151a1a] text-center mb-4 font-pp-mori">
            Unlock More Signals
          </h2>

          {/* Description */}
          <p className="text-[#6b7280] text-center mb-6 leading-relaxed">
            Get access to all Trayd signals and unlock the full potential of our token discovery platform.
          </p>

          {/* Instructions */}
          <div className="bg-[#f9fafb] rounded-xl p-6 mb-6 border border-[#e5e7eb]">
            <h3 className="text-sm font-semibold text-[#151a1a] mb-3">How to Get Access:</h3>
            <ol className="space-y-3 text-sm text-[#6b7280]">
              <li className="flex items-start">
                <span className="font-semibold text-[#4878ff] mr-2">1.</span>
                <span>Send a direct message to our Telegram</span>
              </li>
              <li className="flex items-start">
                <span className="font-semibold text-[#4878ff] mr-2">2.</span>
                <span>Include your account email or username</span>
              </li>
              <li className="flex items-start">
                <span className="font-semibold text-[#4878ff] mr-2">3.</span>
                <span>We'll whitelist your account within 24 hours</span>
              </li>
            </ol>
          </div>

          {/* Telegram Link */}
          <a
            href="https://t.me/ghosid"
            target="_blank"
            rel="noopener noreferrer"
            className="block w-full bg-gradient-to-r from-[#4878ff] to-[#16c784] text-white font-semibold py-3 px-6 rounded-xl text-center hover:shadow-lg transition-all duration-200 mb-4"
          >
            Message on Telegram
          </a>

          {/* Footer */}
          <p className="text-xs text-[#9ca3af] text-center">
            Questions? Contact us at <a href="https://t.me/ghosid" target="_blank" rel="noopener noreferrer" className="text-[#4878ff] hover:underline">@ghosid</a>
          </p>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default UnlockSignalsModal;
